import { conversationSearchKey } from '@/services/chat/invalidateConversationSearch'

/** Central TanStack Query keys — use for invalidation and stable cache identity. */

export const queryKeys = {
  toolkit: {
    catalog: ['toolkit', 'catalog'],
  },
  notes: {
    all: ['notes'],
    detail: (id) => ['notes', id],
  },
  auth: {
    whoami: ['auth', 'whoami'],
  },
  usage: {
    me: (granularity) => ['usage', 'me', granularity],
  },
  workflows: {
    all: ['do-chat', 'workflows'],
  },
  conversations: {
    search: conversationSearchKey,
  },
  integrations: {
    toolkits: ['integrations', 'toolkits'],
    categories: ['integrations', 'categories'],
    connections: ['integrations', 'connections'],
    connection: (id) => ['integrations', 'connections', id],
    proposals: ['integrations', 'proposals'],
    accessReview: (assistantMessageId, reviewId) => ['integrations', 'access-review', assistantMessageId, reviewId],
  },
}
